import React from 'react';
import Tooltip from '@mui/material/Tooltip';

const UiTooltip = (props) => {
  return <Tooltip placement='top' arrow {...props} />;
};

export default UiTooltip;
